import React, { useContext } from "react";
import {
  PaymentInterface,
  ShowPaymentContext,
  WorkYears,
  statusTypePayment,
} from "./types";
import { DoctorInterface } from "../doctors/types";
import { useTranslation } from "react-i18next";

interface CellPaymentInterface {
  doctorPayments: any;
  paymentInfo: PaymentInterface;
  doctorInfo: DoctorInterface;
}

const CellPayment: React.FC<CellPaymentInterface> = ({
  doctorPayments,
  paymentInfo,
  doctorInfo,
}) => {
  const {
    showAddPaymentModal,
    setShowAddPaymentModal,
    showDeletePaymentModal,
    setShowDeletePaymentModal,
    setSubscriptionYear,
    setSelectedPayment,
    setStatusType,
  } = useContext(ShowPaymentContext);

  const { t } = useTranslation();

  const toggleAddPayment = (payment: PaymentInterface, year: string) => {
    setShowAddPaymentModal(!showAddPaymentModal);
    setSubscriptionYear(year);
    setSelectedPayment(payment);
  };

  const toggleDeletePayment = (payment: PaymentInterface) => {
    setShowDeletePaymentModal(!showDeletePaymentModal);
    setSelectedPayment(payment);
  };

  return (
    <>
      {WorkYears.map((year: any) => {
        const hasPaymentForYear =
          doctorPayments.length > 0 &&
          doctorPayments.some(
            (payment: PaymentInterface) =>
              payment.subscriptionYear === year
          );

        const checkDoctorSubscription =
          new Date(doctorInfo?.inscriptionDate).getFullYear() > Number(year);

        const payment = hasPaymentForYear
          ? doctorPayments?.find(
              (payment: PaymentInterface) =>
                payment.subscriptionYear === year
            )
          : null;

        const greentd = hasPaymentForYear && !checkDoctorSubscription;
        const bluetd = hasPaymentForYear && checkDoctorSubscription;
        const redtd = !hasPaymentForYear && !checkDoctorSubscription;

        return (
          <td
            key={year}
            onClick={() => {
              if (checkDoctorSubscription) {
                setStatusType(statusTypePayment.isDoctorSubscribedForYear);
              } else {
                setStatusType("");
              }
              if (payment) {
                toggleDeletePayment(payment);
              } else {
                toggleAddPayment(doctorPayments[0], year);
              }
            }}
            className="whitespace-nowrap px-4 py-2 border-r border-gray-300 text-center cursor-pointer transition hover:bg-gray-100"
          >
            {greentd && (
              <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                {t("Ok")}
              </span>
            )}
            {bluetd && (
              <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
                {payment?.note || t("Note")}
              </span>
            )}
            {redtd && (
              <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-700">
                {t("No")}
              </span>
            )}
          </td>
        );
      })}
    </>
  );
};

export default CellPayment;
